module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-03-jp.c0e7a60ce7b0c8dae8ad807d352852b8.png";